// extracted by mini-css-extract-plugin
module.exports =  {"container":"_103a151b99--container--zp1C3","content":"_103a151b99--content--SCA9c","info":"_103a151b99--info--VHeJo","name":"_103a151b99--name--eivUm"};